import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  hasConsentPdfScalarAnswer,
  shouldShowConsentPdfNotAnswered
} from 'src/app/core/api/consent-form.util';
import { FormFieldConfig, InitialsConfig } from '../../../form-template-model';

@Component({
  selector: 'csi-form-template-initials-field-generator',
  templateUrl: './form-template-initials-field-generator.component.html',
  styleUrls: ['./form-template-initials-field-generator.component.css']
})
export class FormTemplateInitialsFieldGeneratorComponent implements OnInit {
  @Input() config: FormFieldConfig & { typeConfig: InitialsConfig };
  @Input() control: FormControl;
  @Input() formTemplateFieldKey: string;
  @Input() readOnly: boolean;
  @Input() formatForPDF: boolean;
  @Input() isConsentForm: boolean = false;
  @Input() supportingFields: { [key: string]: FormFieldConfig };

  public maxLength = 10;
  /** Consent PDF: show when optional initials were left blank. */
  public showNotAnswered = false;

  ngOnInit() {
    if (this.config && this.config.typeConfig && this.config.typeConfig.maxLength != null) {
      this.maxLength = this.config.typeConfig.maxLength;
    }
    this.showNotAnswered = shouldShowConsentPdfNotAnswered(
      this.isConsentForm,
      this.formatForPDF,
      hasConsentPdfScalarAnswer(this.control && this.control.value)
    );
  }
}
